import $ from "jquery";
import BD_Component from "@bd-core/bd-component";
import compile from "@bd-utils/handlerbars-helper";
import CONFIG from "@bd-core/config";
import { getRoomAnswerById } from "@bd-stores/game-data";
import { 
    getRoomStatus, 
    getFinalTeamAnswers, 
    getIsUsingTobyHint 
} from "@bd-stores/game-progress";
import {
    saveFinalRoomAnswers,
    maybeUpdateRoomStatus,
    updateRoomAnswer
} from "@bd-core/firebase-actions";
import videojs from "video.js";

export class RoomCyclePuzzle extends BD_Component {
    constructor() {
        super();

        this.id = "cycle_puzzle";
        this.templateID = "cycle_puzzle-template";

        this.elms = {
            puzzleScreen: ".js-puzzle-screen",
            codeInputPopup: ".js-openCycle-card",
            inputAnswer: ".js-input-answer",
            checkAnswer: ".js-submit-btn",
            screenItem: ".js-screen-item",
            screenItemBtn: ".js-screen-item-btn",
            closeDisplay: ".js-close-display",
            openCard: ".js-open-card",
            displayScreen: ".js-display",
            timer: ".js-timer",
            switchBtn: ".js-switch",
        };

        this._events = this.getEvents();

        (this.timeHour = 0), 
        (this.timeMinute = 0), 
        (this.timeSecond = 0);

        this.userAnswer = undefined;

        this.videos = [];

        this.videoInterval = null;
    }

    /**
     * @returns {Array<BD_ComponentEvent>}
     */
    getEvents() {
        const elms = this.elms;
        return [
            {
                event: "click",
                selector: elms.screenItemBtn,
                handler: this.toggleDisplay,
            },
            {
                event: "click",
                selector: elms.closeDisplay,
                handler: this.closeDisplay,
            },
            {
                event: "click",
                selector: elms.openCard,
                handler: this.submitAnswers,
            },
            {
                event: "change",
                selector: elms.switchBtn,
                handler: this.onSwitchScreen
            },
            {
                event: "click",
                selector: ".js-close-hint",
                handler: this.handleStateAfterTobyHint
            },        
        ];
    }

    beforeInit() {
        this.render();
        this.setGameState();
        this.handleStateAfterTobyHint();
        this.registerVideos();
    }

    getModifiedData() {
        const modified = { ...this._data };

        const defaultImageBg = `${CONFIG.themeURL}/assets/images/challenge4-bg.png`;

        const _image_bg = this._data.image_bg
            ? this._data.image_bg
            : defaultImageBg;

        const totalItem = this._data.items.length;

        const modifiedData = {
            ...modified,
            image_bg: _image_bg,
            total_item: totalItem,
        };

        return modifiedData;
    }

    render() {
        const modifiedData = this.getModifiedData();

        this._data.total_item = this._data.items.length;
        const htmlTemplate = $("#" + this.templateID).html();
        const html = compile(htmlTemplate, modifiedData);
        $(".app").html(html);
    }

    setGameState() {
        const elms = this.elms;
        const roomID = this.roomId;
        const roomAnswers = getFinalTeamAnswers(roomID);
        const thisRoomStatus = getRoomStatus(roomID);
        const $puzzleScreen = $(elms.puzzleScreen);
        const $submitBtn = $(elms.openCard);

        const possibleStatuses = [
            "is-status-open",
            "is-status-started",
            "is-status-completed",
        ];

        if (thisRoomStatus) {
            const $status = $(".js-room-status");
            $status.removeClass(possibleStatuses);
            $status.addClass(thisRoomStatus);
        }

        if (roomAnswers) {
            // @ts-ignore
            const correctAnswers = roomAnswers.answers || [];
            correctAnswers.forEach((item) => {
                const $screenItem = $(`${elms.screenItem}[data-id="${item}"]`);
                const $switchBtn = $screenItem.find(elms.switchBtn);
                $switchBtn
                .prop("checked", true)
                .prop("disabled", true);
                $switchBtn.parent().addClass("is-active");
            });
        }

        if (thisRoomStatus == "is-status-completed") {
            $puzzleScreen
                .removeClass("is-wrong incorrect")
                .addClass("is-completed is-correct");

            $(".app__page").addClass("is-room-completed");
            $submitBtn.addClass("is-completed");
        }
    }

    handleStateAfterTobyHint() {
        const roomID = this.roomId;
        const isUsingTobyHint = getIsUsingTobyHint(roomID);

        if(isUsingTobyHint) {
            this.setScreenState();
            this.startClock();
        }
    }

    registerVideos() {
        const elms = this.elms;
        const self = this;

        if(self.videos.length) return false;

        const $items = $(elms.screenItem);
        $.each($items, function(index, item) {
            const itemId = $(item).attr("data-id");
            const $videoEl = $(item).find("video");
            const videoUrl = $videoEl.attr("data-src");
            const videoId = $videoEl.attr("id");

            const theVideo = videojs(videoId, {
                controls: true,
                muted: true,
                autoplay: "muted",
                preload: "auto",
                sources: [
                    {
                        src: videoUrl,
                        type: "video/mp4",
                    },
                ],
                techOrder: ["html5"]
            });

            theVideo.on("error", () => {
                console.error("Can't play the video");
            });

            self.videos[itemId] = theVideo;
        });

    }

    setScreenState() {
        const elms = this.elms;
        const $screens = $(elms.screenItem);
        const self = this;

        let onTimer = 0;
        let $firstItem = $screens.first();
        let $currentItem = $firstItem;

        self.videoInterval = setInterval(() => {
            const startCycling = (item) => {
                const $this = $(item);
                const itemId = $this.attr("data-id");
                const on_time = Number($this.attr("data-on"));
                const $displayPopup = $(`${elms.displayScreen}[data-id="${itemId}"]`);
                const theVideo = self.videos[itemId];
    
                const playAnimation = () => {
                    if(theVideo.paused) {
                        try {
                            theVideo.play().catch((error) => {
                                console.error("Unable to start auto play", error);
                            });
                        } catch(error) {
                            console.error(error);
                        }
                    }
                }
    
                const pauseAnimation = () => {
                    if(!theVideo.paused) {
                        theVideo.pause();
                    }
                }

                const setOffState = () => {
                    $this.removeClass("is-after-toby-hint");
                    $displayPopup.removeClass("is-after-toby-hint");
                    pauseAnimation();
                };

                onTimer++;
    
                $this.addClass("is-after-toby-hint");
                $displayPopup.addClass("is-after-toby-hint");
                playAnimation();

                if(onTimer >= on_time) {
                    setOffState();
                    onTimer = 0;
                    let $nextItem = $currentItem.next();

                    if(!$nextItem.length) {
                        $currentItem = $firstItem;
                    } else{
                        $currentItem = $nextItem;
                    }
                }
            };

            startCycling($currentItem);
        }, 1000);
    }

    startClock() {
        let self = this;
        const {timer_slider} = this._data;
        const minTime = 0;
        const maxTime = timer_slider;

        self.timeSecond = minTime;

        const updateTimer = function(percentage) {
            const percent = `${percentage}%`;
            $(".js-timer-txt").css("width", percent);
        };

        this.interval = setInterval(() => {
            self.timeSecond++;
            if (self.timeSecond > maxTime) {
                self.timeSecond = 0;
            }

            const percentage = (100 * self.timeSecond) / maxTime;
            updateTimer(percentage);
        }, 1000);
    }

    // ============================== CUSTOM FUNCTION
    toggleDisplay(e, el) {
        const elms = this.elms;
        const $this = $(el);
        const $screenItem = $this.parents(elms.screenItem);
        const itemId = $screenItem.attr("data-id");
        const $display = $(`${elms.displayScreen}[data-id="${itemId}"]`);
        const isOpen = $display.hasClass("is-open");

        $display.toggleClass("is-open", !isOpen);
    }

    closeDisplay() {
        $(this.elms.displayScreen).removeClass("is-open")
    }

    onSwitchScreen(e, el) {
        const $puzzleScreen = $(this.elms.puzzleScreen);
        const isCompleted = $puzzleScreen.hasClass("is-completed");
        if(isCompleted) return;

        const $this = $(el);
        const itemId = $this.attr("id");
        const isChecked = $this.prop("checked");
        const $switchBtn = $(`${this.elms.switchBtn}[id="${itemId}"]`);

        $puzzleScreen.removeClass("is-wrong");

        if(isChecked) {
            $switchBtn.parent().addClass("is-active");
        } else {
            $switchBtn.parent().removeClass("is-active");
        }

        // this.toggleEnterCodeBtn();
    }

    toggleEnterCodeBtn() {
        const elms = this.elms;
        const $enterCodeBtn = $(elms.openCard);
        const $screenItems = $(elms.screenItem);
        let isHasAnswers = false;

        $.each($screenItems, function(index, value) {
            const $this = $(value);
            const $switchBtn = $this.find(elms.switchBtn);
            const isAnswered = $switchBtn.prop("checked");

            if(isAnswered) {
                return (isHasAnswers = true);
            }
        });

        $enterCodeBtn.prop("disabled", !isHasAnswers);
    }

    submitAnswers(e, el) {
        const elms = this.elms;
        const $el = $(el);

        if ($el.hasClass("is-loading") || $el.hasClass("is-completed")) return;

        $el.addClass("is-loading").prop("disabled", true);

        const $puzzleScreen = $(elms.puzzleScreen);
        const $screenItems = $(elms.screenItem);
        const roomStatus = "is-status-started";
        const roomId = this.roomId;
        let playerAnswers = [];

        $puzzleScreen.removeClass("is-wrong");

       $.each($screenItems, (index, item) => {
            const $this = $(item);
            const itemId = $this.attr("data-id");
            const $switchBtn = $this.find(elms.switchBtn);
            const isChecked = $switchBtn.prop("checked");

            if(isChecked) playerAnswers.push(itemId);
       });

       const roomAnswers = getRoomAnswerById(roomId);
       const correctAnswers = roomAnswers?.answers || [];

       let isCorrect = true;
       if(correctAnswers.length !== playerAnswers.length) {
            isCorrect = false;
        } else {
            correctAnswers.forEach((element) => {
                const isExist = playerAnswers.includes(element);
                if(!isExist) {
                    return (isCorrect = false);
                }
           });
        }

        const answerData = {
            answers: playerAnswers
        };

        if (isCorrect) {
            const onSuccess = () => {
                $(".app__page").addClass("is-room-completed");

                $el
                .removeClass("is-loading")
                .addClass("is-completed");

                $puzzleScreen.addClass("is-correct is-completed");
                maybeUpdateRoomStatus(roomId, "is-status-completed");
            };

            const onError = () => {};

            saveFinalRoomAnswers(roomId, answerData)
                .then(onSuccess)
                .catch(onError);
        } else {
            $el
            .removeAttr("disabled")
            .removeClass("is-loading");

            $puzzleScreen.addClass("is-wrong");
            setTimeout(function() {
                $puzzleScreen.removeClass("is-wrong")
            }, 1500)
            maybeUpdateRoomStatus(roomId, roomStatus);
        }
    }

    updateUserAnswer(answerData) {
        const roomId = this.roomId;
        const currentPlayerId = CONFIG.user.id;

        updateRoomAnswer(roomId, {
            [currentPlayerId]: {
                user_id: currentPlayerId,
                choice: answerData,
            },
        });
    }

    beforeDestroy() {
        const elms = this.elms;
        const $items = $(elms.screenItem);
        const self = this;

        $.each($items, function(index, item) {
            const itemId = $(item).attr("data-id");
            const theVideo = self.videos[itemId];

            theVideo.dispose();
        });

        clearInterval(self.videoInterval);
    }
}
